import { fromEvent } from 'rxjs'
import { startWith, map } from 'rxjs/operators'

const GROUP_CLASS = 'form-image-upload-group'
const FILE_SELECTED_CLASS = GROUP_CLASS + '--file-selected'

export default class FormImageUploadGroupController {
  constructor (element) {
    this._element = element
    this._inputElement = this._element.querySelector('.form-image-upload-group__input')
    this._previewElement = this._element.querySelector('.form-image-upload-group__preview-image')
    this._bindUIActions()
  }

  showInputImage () {
    if (this._previewElement) {
      if (this._inputElement.files && this._inputElement.files[0]) {
        const reader = new FileReader()

        reader.onload = (e) => {
          console.log(e)
          this._previewElement.setAttribute('src', e.target.result)
        }

        reader.readAsDataURL(this._inputElement.files[0]) // convert to base64 string
      }
    }
  }

  _bindUIActions () {
    const inputElement = this._element.querySelector('.form-image-upload-group__input')
    console.log(inputElement)
    const inputElementEvents$ = fromEvent(inputElement, 'change')

    const fileChosen$ = inputElementEvents$.pipe(
      startWith(null),
      map(() => {
        return !!(this._inputElement.files && this._inputElement.files[0])
      })
    )

    fileChosen$.subscribe(fileChosen => {
      if (fileChosen) {
        this._element.classList.add(FILE_SELECTED_CLASS)
        this.showInputImage()
      } else {
        this._element.classList.remove(FILE_SELECTED_CLASS)
      }
    })

    // const openButton = this._element.querySelector('.' + menuOpenButtonClass)
    // if (openButton) {
    //   openButton.addEventListener('click', (e) => {
    //     this.open()
    //     e.preventDefault()
    //   })
    // }
  }
}
